const selectors = {
  carouselContainer: '.product-carousel__redesign--body',
  carouselProducts: '.product-carousel__redesign--product',
  featuredProducts: '.product.product-carousel-redesign__product',
  prevButton: '.product-carousel__redesign--button[data-action="prev"]',
  nextButton: '.product-carousel__redesign--button[data-action="next"]'
};

const carouselProducts = document.querySelectorAll(selectors.carouselProducts);
const featuredProducts = document.querySelectorAll(selectors.featuredProducts);
const prevButton = document.querySelector(selectors.prevButton);
const nextButton = document.querySelector(selectors.nextButton);

let carouselContainer = document.querySelector(selectors.carouselContainer);
let isScrollCarouselEnabled = null;

function goToNextProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex(prod => prod.getAttribute('data-selected') === 'true');
  let nextIndex = (currentIndex + 1) % carouselProducts.length;
  updateSelection(nextIndex);
}

function goToPrevProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex(prod => prod.getAttribute('data-selected') === 'true');
  let prevIndex = (currentIndex - 1 + carouselProducts.length) % carouselProducts.length;
  updateSelection(prevIndex);
}

function updateSelection(newIndex) {
  carouselProducts.forEach((prod, index) => {
    prod.setAttribute('data-selected', 'false');
    featuredProducts[index].setAttribute('data-selected', 'false');
  });

  // Set the 'data-selected' attribute for the new active product
  carouselProducts[newIndex].setAttribute('data-selected', 'true');
  featuredProducts[newIndex].setAttribute('data-selected', 'true');

  const container = carouselProducts[newIndex].parentElement;
  const containerWidth = container.offsetWidth;
  const itemLeft = carouselProducts[newIndex].offsetLeft;
  const itemRight = itemLeft + carouselProducts[newIndex].offsetWidth;

  if (itemLeft < container.scrollLeft) {
    container.scrollLeft = itemLeft - 40;
  } else if (itemRight > container.scrollLeft + containerWidth) {
    container.scrollLeft = itemRight - containerWidth + 40;
  }

  // Generate a resize event to recalculate any dependencies on window size (Flickity issue)
  window.dispatchEvent(new Event('resize', { bubbles: true }));
}

function isScrollEnabled(container) {
  return container.scrollWidth > container.clientWidth;
}

if (carouselContainer) {
  isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
  carouselContainer.setAttribute('data-scroll', isScrollCarouselEnabled);
}

window.addEventListener('resize', () => {
  carouselContainer = document.querySelector(selectors.carouselContainer);

  if (carouselContainer) {
    isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
    carouselContainer.setAttribute('data-scroll', isScrollCarouselEnabled);
  }
});

if (carouselProducts && featuredProducts) {
  carouselProducts.forEach((product, index) => {
    product.addEventListener('click', () => updateSelection(index));
  });
}

if (prevButton && nextButton) {
  prevButton.addEventListener('click', goToPrevProduct);
  nextButton.addEventListener('click', goToNextProduct);
}